import type { AuthUser } from '@/types';
import { PAINEL_OFICINA_BASE, userHomeIsPainelOficina } from '@/lib/painelOficina';

/**
 * Lista de módulos do sistema para exibição no cadastro de usuários (permissões).
 * Deve estar em sincronia com os itens de navegação do Sidebar.
 */
export interface SystemModule {
  name: string;
  href: string;
}

export const SYSTEM_MODULES: SystemModule[] = [
  { name: 'Dashboard', href: '/dashboard' },
  { name: 'Títulos', href: '/titulos' },
  { name: 'Clientes/Fornecedores', href: '/clientes-fornecedores' },
  { name: 'Gestor de Cobranças', href: '/gestor-cobrancas' },
  { name: 'Chat Interno', href: '/internal-chat' },
  { name: 'Importação', href: '/importacao' },
  { name: 'Validação Kanban', href: '/kanban-validacao' },
  { name: 'Relatórios', href: '/relatorios' },
  { name: 'Cobranças WhatsApp', href: '/whatsapp-cobrancas-report' },
  { name: 'Desempenho do Operador', href: '/operador-performance-report' },
  { name: 'Empresas', href: '/empresas' },
  { name: 'Usuários', href: '/usuarios' },
  { name: 'Logs de Acesso', href: '/log-acesso' },
  { name: 'Etapas Kanban', href: '/kanban-etapas' },
  { name: 'Configuração de Kanbans', href: '/kanban-config' },
  { name: 'Configurações', href: '/configuracoes' },
  { name: 'Aplicativo ZehMotoca', href: '/configuracoes/aplicativo-zehmotoca' },
  { name: 'Notificações Push', href: '/push-notifications' },
  { name: 'Downloads', href: '/downloads' },
  { name: 'Mercado do Zeh', href: '/mercado-zeh' },
  { name: 'Diretoria', href: '/diretoria' },
  { name: 'Painel Oficina', href: PAINEL_OFICINA_BASE },
];

/**
 * Retorna a rota inicial do usuário: o portal central é a porta de entrada padrão.
 */
export function getDefaultHomePath(user: AuthUser | null): string {
  if (!user) return '/portal';
  const allowed = user.allowedModules;
  const hasList = Array.isArray(allowed) && allowed.length > 0;
  if (!hasList) return '/portal';
  if (userHomeIsPainelOficina(allowed)) return PAINEL_OFICINA_BASE;
  return '/portal';
}
